import styled from '@emotion/styled';

export const ProductivityContainer = styled.div`
    display:flex;
    flex-direction:column;
    flex: 1 0 auto;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 16px;
    padding: 16px;
`;
export const RiskContainer = styled.div`
    display:flex;
    flex-direction:column;
    width: 453px;
    min-width: 453px;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 16px;
    padding: 16px;
`;
export const DashboardSmallContainer = styled.div`
    
    flex: 1 0 auto;
    border: 1px solid ${props => props.theme.colors.gray};
    border-radius: 16px;
    position: relative;
`;
export const SmallLabelCard = styled.div<{ negative: boolean; }> `
  padding: 0 9px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.gray};
  background-color: ${props => !props.negative ? 'rgba(144, 249, 11, 0.25)' : 'rgba(249, 11, 11, 0.25)'};
`;
